module.exports = __webpack_public_path__ + "static/media/threaded-message.d8dc44cd.svg";